<template>
  <v-row fill-height align="center" justify="center" no-gutters>
    <v-col cols="6">
      <v-card flat>
        <v-card-text class="d-flex justify-center pb-5">
          <v-text-field solo :placeholder="$i18n.t('placeHolder')" rounded height="55px" class="text-h5 containerBorder"
            hide-details :append-icon="expand ? '' : 'mdi-magnify'" dense :value="searchKeyword" v-model="searchKeyword"
            clearable>
          </v-text-field>
          <!-- <v-icon size="35" class="ml-2" v-if="expand" @click="expand = !expand;">mdi-keyboard-off-outline</v-icon> -->
        </v-card-text>
        <v-expand-transition v-if="!getPhysicalKeyboard">
          <v-card-text class="d-flex justify-center ma-0 pa-0">
            <SimpleKeyboard @onChange="onChange" @onKeyPress="onKeyPress" :input="searchKeyword" class="keyboard">
            </SimpleKeyboard>
          </v-card-text>
        </v-expand-transition>
      </v-card>
    </v-col>
    <v-col cols="12" align="center">
      <v-card class="pa-4 containerBorder" width="95%" flat :height="viewBoxHeight + 25">
        <v-data-table hide-default-footer :items-per-page="-1" :headers="header" :height="viewBoxHeight" :items="list"
          :loading="loading" loading-text="Fetching latest data. Please wait..." fixed-header>
          <template v-slot:item.caseNumber="{ item }">
            <span v-if="item.count > 1"><strong>Multiple Cases</strong></span>
            <strong v-else>{{ item.caseNumber }}</strong>
          </template>

          <template v-slot:item.partyName="{ item }">
            <div class="my-7" v-if="item.partyName === ''"> - </div>
            <div class="my-7" v-else>
              {{ item.partyName }}
            </div>
          </template>

          <template v-slot:item.hearingLocation="{ item }">
            <span>{{([...new Set(item.hearings.map(h => h.hearingLocation))]).toString()}}</span>
            <!-- <span v-if="item.count > 1">{{ item.hearings[0].hearingLocation }}</span>
            <span v-else>{{ item.hearings[0].hearingLocation }}</span> -->
          </template>

          <template v-slot:item.time="{ item }">
            <span>{{ item.hearings[0].time | dateAndTime }}</span>
          </template>

          <template v-slot:item.checkin="{ item }">
            <v-btn v-if="item.count > 1 && getMultiCourtroom(item)" color="primary" @click="checkin(item)">Tap for more
              information</v-btn>
            <v-btn v-else-if="item.hearings[0].hearingLocation === '110'" color="primary" @click="checkin(item)">Tap to
              Check-in</v-btn>
            <span
              v-else-if="['300', '305', '407', '410', '204', '206'].includes(item.hearings[0].hearingLocation)">Please
              go
              the
              <strong>downtown
                courthouse</strong> <br>located at <strong>119 W. Madison Street. </strong></span>
            <span v-else-if="['210', '210D', '223R'].includes(item.hearings[0].hearingLocation)"><strong>Check-in not
                required</strong> <br> (Please proceed to your courtroom on second floor.)</span>
            <v-btn v-else color="secondary" @click="visitClerk()">Visit Clerk's office</v-btn>
          </template>

        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SimpleKeyboard from "@/components/SimpleKeyboard";
import { mapGetters } from "vuex";
import moment from "moment";
import MiniSearch from 'minisearch'
import { CHECK_IN_SEARCH_PROMPT, isCheckInWindow } from '@/utils/checkInSchedule'
export default {
  name: "hearingList",
  components: {
    SimpleKeyboard,
  },
  data() {
    return {
      expand: true,
      searchKeyword: null,
      viewBoxHeight: 650,
      loading: true,
      header: [
        {
          text: "Case Number",
          align: "center",
          value: "caseNumber",
          width: "200",
          sortable: false,
          class: "text-h6 font-weight-black text-decoration-underline",
        },
        {
          text: "Parties Name",
          align: "start",
          value: "partyName",
          width: "500",
          sortable: false,
          class: "text-h6 font-weight-black text-decoration-underline",
        },
        {
          text: "Court Room Location",
          align: "center",
          value: "hearingLocation",
          width: "300",
          sortable: false,
          class: "text-h6 font-weight-black text-decoration-underline",
        },
        {
          text: "Date",
          align: "center",
          value: "date",
          sortable: false,
          class: "text-h6 font-weight-black text-decoration-underline",
        },
        {
          text: "Time",
          align: "center",
          value: "time",
          sortable: false,
          class: "text-h6 font-weight-black text-decoration-underline",
        },
        {
          text: "Check-in",
          align: "center",
          value: "checkin",
          sortable: false,
          class: "text-h6 font-weight-black text-decoration-underline",
        }
      ],
    };
  },
  computed: {
    ...mapGetters(["hearingInfo", "getDefaultLocation", "getMaps", "getPhysicalKeyboard", "getNotifyClerkViewer", "getImageViewer"]),
    list() {
      if (this.searchKeyword === "" || this.searchKeyword === null) {
        console.log("Hearing List: ", this.hearingInfo.slice().sort(this.customSort))
        return this.hearingInfo.slice().sort(this.customSort);
      } else {
        let miniSearch = new MiniSearch({
          fields: ['partyName', 'caseNumber'],
          storeFields: ['partyName', 'caseNumber', 'date', 'hearings', 'count'],
          searchOptions: {
            fuzzy: 0.2,
            prefix: true
          }
        })

        miniSearch.addAll(this.hearingInfo)

        let results = miniSearch.search(this.searchKeyword.toLowerCase())
        console.log("Results at Mini Search:", results)
        return results
      }
    },

  },
  watch: {
    expand(n, o) {
      this.$store.commit('setRequestQna', false)
      this.$store.commit("setIsThinking", false)
      this.$store.commit("setSpeechRecognitionHandler", false);
      if (n) {
        this.viewBoxHeight = 370;
      } else {
        this.viewBoxHeight = 650;
        //user session logging
      }
    },
    getNotifyClerkViewer(n, o) {
      console.log('Notify clerk value changed: ', n)
      if (!n) {
        this.searchKeyword = null
      }
    },
    getImageViewer(val) {
      if (!val) {
        this.searchKeyword = null
      }
    }
  },
  methods: {
    getMultiCourtroom(item) {
      let locations = [...new Set(item.hearings.map(h => h.hearingLocation))]
      if (locations.length > 1) {
        if (locations.includes('110')) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    checkin(item) {
      this.$store.commit('setSelectedHearing', item)
      window.stopSpeech();
      this.$store.dispatch('avatarSpeak', "Do you have an attorney representing you?")
      this.$store.commit('setNotifyClerkViewer', true)
    },
    customSort(a, b) {
      if (a.partyName === '' && b.partyName === '') {
        return 0;
      } else if (a.partyName === '') {
        return -1;
      } else if (b.partyName === '') {
        return 1;
      } else {
        return a.partyName.localeCompare(b.partyName);
      }
    },
    async visitClerk() {
      window.stopSpeech();
      const speech = this.$store.dispatch('avatarSpeak', "Please go to Circuit Clerk/Traffic Fines office for more information.")
      this.$store.commit('setImageViewer', { show: true })
      await speech;
      // Only end the session automatically while actually in check-in
      // mode — outside a scheduled window this page is just part of the
      // normal menu, so it shouldn't reset the whole kiosk.
      if (isCheckInWindow()) {
        setTimeout(() => {
          this.$store.commit('setResetKioskStatus', true);
          this.$store.dispatch('kioskStartOver');
        }, 3000);
      }
    },
    getPartyInfo(partyInfo) {
      console.log("Party case information: ", partyInfo)
    }
  },
  filters: {
    dateAndTime(val) {
      if (!val) {
        return "-";
      }

      return moment(val, ['hmmA', 'h:mmA']).format('h:mm A')
      //return 'Today - ' + parsedTime.toLocaleString('en-US', options);
    },
    trimLength(val) {
      if (val === null || val === undefined) return val;
      if (val.length <= 30) {
        return val;
      }
      return `${val.substring(0, 23)}...`;
    },
  },
  mounted() {
    this.loading = false;
    // Set directly here (not just relying on the Home menu tile's CMS-driven
    // pageHeader) so it's always correct even when the schedule-based
    // auto-redirect lands here without going through the menu.
    this.$store.commit('setPageHeader', 'Check-In');
    // Announce this screen's own intro every time it's shown, rather than
    // relying on recognition.vue's face-detection greeting (which only
    // fires once per session and may have already happened elsewhere before
    // landing here).
    this.$store.commit(
      "setTextBubbleText",
      CHECK_IN_SEARCH_PROMPT
    );
    //this.$store.dispatch('avatarSpeak', CHECK_IN_SEARCH_PROMPT);
  }
};
</script>

<style>
.hg-theme-default {
  background-color: #bcbcbc !important;
  font-weight: bolder !important;
  font-size: x-large !important;
}
</style>

<i18n>
  {
    "en": {
        "placeHolder": "Tap to search by Full Name or Case Number",
        "noCase": "Can't find your case?"
      },
    "es":{
        "placeHolder": "Toque para buscar por nombre completo o número de caso",
        "noCase": "¿No puedes encontrar tu caso?"
      }
  }
</i18n>